'use client';

import { TAG_TYPES, getQueryClient, persister } from '@lib/config';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HydrationBoundary, dehydrate } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactQueryStreamedHydration } from '@tanstack/react-query-next-experimental';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import { Toaster } from '~/modules/common/components/ui/toaster';

export function Providers ({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();
  const dehydratedState = dehydrate(queryClient);

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        buster: 'queryClient.v1',
        maxAge: Infinity,

        persister,
        dehydrateOptions: {
          shouldDehydrateQuery: ({ queryKey }) =>
            queryKey[0] === TAG_TYPES.AUTH
        }
      }}
    >
      <ReactQueryStreamedHydration>
        <HydrationBoundary state={dehydratedState}>
          <GoogleOAuthProvider
            clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ''}
          >
            {children}
          </GoogleOAuthProvider>
        </HydrationBoundary>
      </ReactQueryStreamedHydration>
      <Toaster />
      <ReactQueryDevtools />
    </PersistQueryClientProvider>
  );
}
